(function(angular){
'use strict';
run.$inject = ["DataService"];
championKerningFix.$inject = ["$timeout"];
DataService.$inject = ["$q", "$http"];
angular.element(document).ready(function (event) {

    var modules = [];
    
    modules.push('ngAnimate'); 
    modules.push('ngStorage'); 
    modules.push('ngSanitize'); 

    angular.module('uniavis', modules)
        .animation('.intro', intro)
        .component('archive', archive)
        .component('cookie', cookie)
        .component('eventArchive', eventArchive)
        .component('headerNav', headerNav)
        .component('newsletterForm', newsletterForm)
        .component('pageProgress', pageProgress)
        .component('searchForm', searchForm)
        .component('secret', secret)
        .component('sliderWrapper', sliderWrapper)
        .component('timeago', timeago)
        .component('timespan', timespan)
        .directive('anchorClick', anchorClick)
        .directive('championKerningFix', championKerningFix)
        .directive('detach', detach)
        .directive('facebookShare', facebookShare)
        .directive('factbox', factbox)
        .directive('fadein', fadein)
        .directive('freezeBody', freezeBody)
        .directive('momentize', momentize)
        .directive('twitterShare', twitterShare)
        .directive('videoResizer', videoResizer)
        .factory('DataService', DataService)
        .run(run);

    // Bootstrap manually
    angular.bootstrap(document.getElementById('ng-app'), ['uniavis']);
});
/**
 * @ngInject
 */

function intro() {

    return {
        addClass : function (elem, className, done) {
            console.log("addClass");
        },
        removeClass : function (elem, className, done) {
            console.log("removeClass");
            if (className === 'ng-hide'){
                
                console.log("remove ng-hide");
                // Animation here
            }
        },
        enter : function (elem, done) {
            console.log("done done done");
        },
        leave : function (elem, done) {
            console.log("leave");
        }
    };
}
var archive = {
    bindings : {
        moreLabel : '@',
        archiveLabel : '@',
        archiveHref : '@'
    },
    controller : function ArchiveCtrl ($element, DataService) {
        function init () {
            ctrl.limit = 6;
        }

        function link () {
        }

        function constructByline (contributors) {
            var names = [];
            _.each(contributors, function addContributorName (contributor, i) {
                names[names.length] = contributor.contributor_name;
            });
            return names.join(', ');
        }

        function onGetArchiveSuccess (response) {
            console.log("onGetArchiveSuccess", response);
            data = response.data;
            ctrl.items = response.data.posts;
        }

        function onGetArchiveSuccess (response) {
            console.log("onGetArchiveSuccess", response);
            data = response.data;
            ctrl.items = [];
            _.each(response.data.posts, function createItem (post) {
                if (post.contributors && post.contributors.length > 0) {
                    post.byline = constructByline(post.contributors);
                    post.bylinePrefix = (wpmlLang === 'da') ? 'af: ': 'by: ';
                }
                ctrl.items.push(post);
            });
        }

        function onGetArchiveError (error) {
            console.log("onGetArchiveError", error);
        }

        function onWindowScroll (event) {

            if ( !ctrl.items ) {
                var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // For ie 11
                if (($element[0].offsetTop - scrollTop) < window.innerHeight) {
                    window.removeEventListener('scroll', onWindowScroll);
                    DataService.getArchive('post', 15)
                        .then(onGetArchiveSuccess, onGetArchiveError);   
                }
                else {
                    // HEJ
                }            
            }

        }

        var ctrl = this;
        var data;

        this.showMore = function () {
            ctrl.limit += 3;
        }

        this.$onInit = init;
        this.$postLink = link;

        window.addEventListener('scroll', onWindowScroll);
        onWindowScroll();
    },
    templateUrl : themeUrl + '/assets/static/html/archive.component.html?v=' + assetVersion,
};
var banner = {
    bindings : {
        source : "@bannerSrc",
        dd : "@"
    },
    controller : function BannerCtrl ($element, $sce) {

        function init () {
            
            ctrl.trustedsrc = $sce.trustAsResourceUrl(ctrl.source);
        }

        function link () {
            console.log("WHAT", ctrl.trustedsrc, ctrl.dd);
            ctrl.ready = true;
            // $element[0].style.height = ctrl.height+"px";
            // $element[0].style.width = ctrl.width+"px";

            // var script = document.createElement('script');
            // script.type = 'text/javascript';
            // script.src = ctrl.trustedsrc;
            // $element[0].appendChild(script);
        }

        var ctrl = this;
        this.$onInit = init;
        this.$postLink = link;
    },
    template : '<div class="banner" ng-if="$ctrl.ready"><script type="text/javascript" ng-src="{{$ctrl.trustedsrc}}"></script></div>'
};
/**
 * @ngInject
 */

var cookie = {
    controller : cookieCtrl,
    transclude : true,
    template : '<div ng-transclude></div>'
};

function cookieCtrl($scope, $element, $localStorage) {
	var ctrl = this;

	function onInit() {
		ctrl.storage = $localStorage;
	}
	this.close = function close() {
		console.log("hello");
		ctrl.storage.cookieAccepted = true;
	};

	ctrl.$onInit = onInit;

}
var eventArchive = {
    bindings : {
        moreLabel : '@',
        archiveLabel : '@',
        archiveHref : '@',
        pageSize : '@'
    },
    controller : function EventArchiveCtrl (DataService) {
        function init () {
            ctrl.limit = 10;

            // Tell service to load all (on the calender) or to load a limited number (default behaviour in the footer)

            DataService.getArchive('event', ctrl.pageSize)
                .then(onGetArchiveSuccess, onGetArchiveError);
        }

        function link () {

        }

        function onGetArchiveSuccess (response) {
            console.log("onGetArchiveSuccess", response);
            data = response.data;
            var month;
            ctrl.items = [];
            _.each(response.data.posts, function createItem (post) {
                // console.log(month, moment(post.date, 'YYYY-MM-DD H:m:s').month());
                if (angular.isUndefined(month) || month != moment(post.date, 'YYYY-MM-DD H:m:s').month()) {
                    month = moment(post.date, 'YYYY-MM-DD H:m:s').month();
                    post.month = moment(post.date).format('MMMM YY');
                }
                ctrl.items.push(post);
            });
        }

        function onGetArchiveError (error) {
            console.log("onGetArchiveError", error);
        }

        var ctrl = this;
        var data;

        this.showMore = function () {
            ctrl.limit = ctrl.items.length;
        }

        this.$onInit = init;
        this.$postLink = link;
    },
    templateUrl : themeUrl + '/assets/static/html/event-archive.component.html',
};
var headerNav = {
    controller : function headerNavCtrl ($element) {
        var ctrl = this;

        function init () {

        }

        function link () {

        }

        this.expandMenu = function expandMenu () {
            ctrl.openNav = !ctrl.openNav;
            ctrl.openSearch = false;
            console.log(ctrl.openNav);
        };

        this.expandSearch = function expandSearch () {
            ctrl.openSearch = !ctrl.openSearch;
            ctrl.openNav = false;
        };

        this.openNav = false;
        this.openSearch = false;
        this.$onInit = init;
        this.$postLink = link;
    },
    transclude : true,
    template : '<div ng-transclude></div>'
};
var newsletterForm = {
	bindings: {
		terms: '@',
		success: '@'
	},
	controller: function NewsletterCtrl ($element, $scope, $window, $timeout, DataService) {
		var ctrl = this;
		// console.log(ctrl.terms);

		function onInit(){

			ctrl.formData = {
				subscription : "studerende"
			};
			ctrl.submitSuccess = false;
		}

		function link(){
			$element[0].setAttribute("terms", "");
			$element[0].setAttribute("success", "");
		}

		function reset () {
			ctrl.submitSuccess = false;
			ctrl.formData = {
				subscription : "studerende"
			};
			$scope.newsletterForm.$setPristine();
			$scope.newsletterForm.$setUntouched();
			
		}

		function onSignupComplete(response) {
			ctrl.submitSuccess = true;
			ctrl.submitting = false;
			$timeout(reset, 5000);
		}

		function onSignupError(error) {
			ctrl.submitting = false;
			ctrl.submitSuccess = true;
			// $window.alert('An error occurred during signup');
		}

		this.submitForm = function submitForm (isValid) {
			if (isValid) {
				ctrl.submitting = true;
				DataService.newsletterSignup(ctrl.formData.email, ctrl.formData.subscription).then(onSignupComplete, onSignupError);
			}
		}	

		ctrl.$onInit = onInit;
		ctrl.$postLink = link;
	},
	templateUrl: themeUrl + '/assets/static/html/newsletter.component.html?v=' + window.assetVersion
};
var pageProgress = {
    controller : function PageProgressCtrl ($element) {

        var ctrl = this,
            bar;

        function init () {
            ctrl.progress = 0;
        }

        function link () {
            bar = $element[0].querySelector('.progress-bar');
            bar.addEventListener('click', onBarClick);
            window.addEventListener('scroll', setProgress);
            window.addEventListener('resize', setProgress);
            setProgress();
        }

        function setProgress () {
            try {
                var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // For ie 11
                ctrl.progress = scrollTop / (document.body.offsetHeight - window.innerHeight) * 100;
                bar.style.width = ctrl.progress + "%";
                $scope.$digest();
            }
            catch (e) {
                // console.log("Waa");
            }
        }

        function onBarClick (event) {
            TweenMax.to(window, .35, {scrollTo:{x:0, y:0}});
        }

        this.$postLink = link;
        this.$onInit = init;
    },
    template : '<div class="progress-bar hide-from-print"></div>'
};
var pageReact = {
    templateUrl : themeUrl + '/'
};
var searchForm = {
    bindings : {
        activate : '<'
    },
    controller : function SearchFormCtrl ($element, $timeout) {
        
        var searchField;

        function link () {
            searchField = $element[0].querySelector('input');
        }

        function onChanges (changes) {
            if (ctrl.activate) {
                
                $timeout(function(){
                    searchField.focus();
                }, 0);
            }
        }

        var ctrl = this;

        this.searchAction = baseUrl;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl : themeUrl + '/assets/static/html/search-form.component.html',
};
var secret = {
    bindings : {
        url : '@',
        text : '@'
    },
    transclude : true,
    controller : function VelvetCtrl ($element) {
        
        var hoverElement, margin = 10, hoverAnim = new TimelineMax({paused:true});

        function link () {
            
            hoverElement = $element[0].querySelector('.secret-hover');

            $element[0].addEventListener('mouseenter', onMouseEnter);
            $element[0].addEventListener('mouseleave', onMouseLeave);

            // add touch events
            if (Modernizr.touchevents) {
                // console.log("add touch listeners")
                $element[0].addEventListener('touchend', onTouchEnd);
                window.addEventListener('scroll', onWindowScroll);
            }

            TweenMax.set(hoverElement, {y:25});

            hoverAnim.add(new TweenMax(hoverElement, .25, {y:0, opacity:1}))
        }

        function onMouseEnter (event) {
            // console.log("mouseenter");
            $element[0].classList.add('active');
            
            var minX = margin - event.target.offsetLeft;
            var maxX = window.innerWidth - hoverElement.offsetWidth - event.target.offsetLeft - margin;
            var desiredX = Math.max(minX, Math.min(event.clientX - event.target.offsetLeft - hoverElement.offsetWidth * 0.5, maxX));
            TweenMax.set(hoverElement, {x:desiredX});

            hoverAnim.play();
        }

        function onTouchEnd (event) {
            // console.log("touchstart");
            $element[0].classList.add('active');
            var minX = margin - event.target.offsetLeft;
            var maxX = window.innerWidth - hoverElement.offsetWidth - event.target.offsetLeft - margin;
            var desiredX = Math.max(minX, Math.min(0, maxX));
            TweenMax.set(hoverElement, {x:desiredX});
            hoverAnim.play();
        }

        function onMouseLeave (event) {
            // console.log("mouseleave");
            hoverAnim.reverse();
            $element[0].classList.remove('active');
        }

        function onWindowScroll (event) {
            // console.log("onWindowScroll");
            hoverAnim.reverse();
            $element[0].classList.remove('active');
        }

        this.$postLink = link;
        this.$onInit = function () {
            // console.log("what");
        };
    },
    template : '<span class="secret-trigger" ng-transclude>' +
    '</span>' +
    '<span class="secret-hover" ng-class="$ctrl.url?\'image\':\'text\'">' +
        '<img ng-src="{{$ctrl.url}}" ng-if="$ctrl.url" />' +
        '<p ng-bind="$ctrl.text" ng-if="$ctrl.text"></p>' +
    '</span>'
};
/**
** @ngInject
*/

var sliderWrapper = {
    bindings : {
        size : '@',
        credit : '@'
    },
	controller: ["$element", "$timeout", "$scope", function SliderWrapperCtrl($element, $timeout, $scope) {
		var ctrl = this;
		var swiperInitDelay = 0;
        var swiper;
        
		function init() {
        }

        function link() {     
            $timeout(initSwiper, swiperInitDelay);
        }

        function onSlideChangeStart (swiper) {
            var slide = swiper.slides[swiper.activeIndex];
            ctrl.captionStyle = slide.getAttribute('caption-style');
            ctrl.captionText = slide.getAttribute('caption');
            ctrl.photoCredit = slide.getAttribute('photo-credit');
            try {
                $scope.$digest();
            } catch(ex) {

            }
        }

        function initSwiper (swiper) {
            var swiperSettings = {
                nextButton : '.swiper-button-next',
                prevButton : '.swiper-button-prev',
                pagination : '.swiper-pagination',
                paginationType: 'fraction',
                keyboardControl : true,
                loop :  true,
                onSlideChangeStart : onSlideChangeStart
            };
            if(ctrl.size === "bg-cover") {
                swiperSettings.centeredSlides = true;
                swiperSettings.slidesPerView = 'auto';
                
            }
            swiper = new Swiper('.swiper-container', swiperSettings);
        }

		ctrl.$onInit = init;
		ctrl.$postLink = link;
	}],
    transclude : true,
	template : [
                '<div class="slider-container" ng-transclude></div>',
                    '<div class="slide-info {{$ctrl.captionStyle}}">',
                        '<div class="caption-container">',
                            '<div class="swiper-pagination"></div>',
                            '<p class="caption">{{$ctrl.captionText}}</p>',
                            '<div class="photo-credit" ng-if="$ctrl.photoCredit">',
                                '<span class="foto"> {{$ctrl.credit}}: </span>',
                                '<span class="creditor">{{$ctrl.photoCredit}}</span>',
                            '</div>',
                        '</div>',
                    '</div>',
                '</div>'
    ].join('')
};
var timeago = {
    bindings : {
        date : '@'
    },
    controller : function TimeagoCtrl () {
        var ctrl = this;

        function link () {
            ctrl.fromNow = moment(ctrl.date, 'YYYY-MM-DD HH:mm:ss').fromNow();
        }

        this.$postLink = link;
    },
    template : '<span ng-bind="$ctrl.fromNow"></span>'
}
var timespan = {
    bindings : {
        from : '@',
        to : '@'
    },
    controller : function TimespanCtrl () {
        function link () {
            ctrl.startMoment = moment(ctrl.from, 'YYYY-MM-DD HH:mm:ss');
            ctrl.endMoment = moment(ctrl.to, 'YYYY-MM-DD HH:mm:ss'); // might be invalid
            ctrl.span = ctrl.startMoment.format('Do MMM YYYY, HH:mm');
            if (ctrl.to) {
                if (ctrl.startMoment.dayOfYear() == ctrl.endMoment.dayOfYear()) {
                    ctrl.span += ' - ' + ctrl.endMoment.format('HH:mm');
                }
                else {
                    ctrl.span += ' - ' + ctrl.endMoment.format('Do MMM YYYY, HH:mm');
                }
            }
        }

        var ctrl = this;
        this.$postLink = link;
    },
    template : '<span ng-bind="$ctrl.span"></span>'
}
/**
 * @ngInject
 */
function run(DataService) {
    console.log("RUN FORREST RUN");
}
/**
 * @ngInject
 */

function anchorClick () {

    function link (scope, elem, attrs) {
        elem[0].addEventListener('click', function onClick (event) {

        	function onAutoKill () {
        		console.log("killed");
        	}
            var target = document.getElementById(attrs.anchorClick);
            TweenMax.to(window, 0.55, {scrollTo:{y:target.offsetTop, onAutoKill: onAutoKill, autoKill : false}});
        });
    }

    return {
        link : link
    };
}
/**
 * @ngInject
 */

function championKerningFix ($timeout) {

	function link (scope, elem, attrs) {
		var styles = getComputedStyle(elem[0]);
		if (styles.fontFamily.toLowerCase().indexOf('champion') != -1 && styles.fontFamily.toLowerCase().indexOf('heavy') != -1) {
			if (elem[0].textContent.toUpperCase().indexOf('VÆ') != -1) {
				elem[0].innerHTML = elem[0].innerHTML.split('VÆ').join('<span class="fix-kerning">V</span>Æ');
				elem[0].innerHTML = elem[0].innerHTML.split('væ').join('<span class="fix-kerning">v</span>Æ');
				elem[0].innerHTML = elem[0].innerHTML.split('Væ').join('<span class="fix-kerning">V</span>Æ');
			}
			if (elem[0].textContent.toUpperCase().indexOf('TÆ') != -1) {
				elem[0].innerHTML = elem[0].innerHTML.split('TÆ').join('<span class="fix-kerning">T</span>Æ');
				elem[0].innerHTML = elem[0].innerHTML.split('tæ').join('<span class="fix-kerning">t</span>Æ');
				elem[0].innerHTML = elem[0].innerHTML.split('Tæ').join('<span class="fix-kerning">T</span>Æ');
			}
		}
	}

	return {
		restrict : 'A',
		link : link
	}
}
/**
 * @ngInject
 */

function detach () {

    function link (scope, elem, attrs) {
        
        // var stickyElement = document.querySelector('.header__menu');
        // var anchorElement = document.querySelector('.header__anchor');
        var controlElement = document.querySelector(attrs.detachControl);

        function onWindowScroll (event) {
            var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // For ie 11
            if ((controlElement.offsetTop - scrollTop) > window.innerHeight) {
                elem[0].classList.add("detach");
            }
            else {
                elem[0].classList.remove("detach");
            }            
        }
        window.addEventListener('scroll', onWindowScroll);
        onWindowScroll();
    }

    return {
        restrict: 'A',
        link: link
    };
}
/**
 * @ngInject
 */

function facebookShare () {
    function link (scope, elem, attrs) {

        var leftPosition, topPosition;
        var socialWindowWidthFb = 626;
        var socialWindowHeightFb = 436;
        leftPosition = (window.screen.width / 2) - ((socialWindowWidthFb / 2) + 10);
        topPosition = 200;
        var windowFeaturesFb = "status=no,height=" + socialWindowHeightFb + ",width=" + socialWindowWidthFb + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";

        elem[0].addEventListener('click', function(event){
            if(attrs.facebookShare == "") attrs.facebookShare = window.location.href;
            window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(attrs.facebookShare) + "", "facebook", windowFeaturesFb);
        });
    }

    return {
        restrict : 'A',
        link : link
    };
}
/**
 * @ngInject
 */

function factbox () {


	function link ($scope, $elem, $attrs) {

		var handle, factboxElement;

		function onHandleClick (event) {
			factboxElement.classList.toggle('open');
			TweenMax.to(window, 0.55, {scrollTo:{y:factboxElement.offsetTop}});
		}
		
		factboxElement = $elem[0];
		handle = document.createElement('div');
		handle.classList.add('factbox-handle');
		handle.addEventListener('click', onHandleClick);

		factboxElement.appendChild(handle);
	}


	return {
		restrict : 'C',
		link : link
	}
}
function fadein () {

    function link (scope, elem, attrs) {
        

        function onWindowScroll(event) {
            var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // For ie 11
            if (elem[0].offsetTop - window.innerHeight / 2 < scrollTop) {
                console.log('fadein');
                elem[0].classList.add('visible');
            }
        }

        window.addEventListener('scroll', onWindowScroll);
        onWindowScroll();
        
    }

    return {
        restrict: 'A',
        link: link
    };
}
/**
 * @ngInject
 */

function freezeBody () {

	function onFreezeTriggerOn () {
		
		var scrollbarWidth = window.innerWidth - document.body.offsetWidth;

		document.body.style.maxHeight = '100vh';
		document.body.style.overflow = 'hidden';
		document.body.style.paddingRight = scrollbarWidth+'px';

	}

	function onFreezeTriggerOff () {
		document.body.style.maxHeight = 'none';
		document.body.style.overflow = 'visible';
		document.body.style.paddingRight = '0px';
	}

	function link (scope, elem, attrs) {

		elem[0].addEventListener(attrs.triggerOn, onFreezeTriggerOn);
		elem[0].addEventListener(attrs.triggerOff, onFreezeTriggerOff);
	}

	return {
		restrict : 'A',
		link : link,
	}
}
/**
 * @ngInject
 */

function inlineSvg() {

	function getTemplateUrl (elem, attr) {
		return attr.path;
	} 

	return {
		restrict: "E",
		templateUrl: getTemplateUrl,
		replace : true
	}
}
/**
 * @ngInject
 */

function momentize () {
    function link (scope, elem, attrs) {
        
        moment.locale(wpmlLang);

        console.log("moment-local", moment(attrs.momentize.toString(), attrs.momentizeParse).format(attrs.momentizeDisplay));
        console.log("moment-utc", moment.utc(attrs.momentize.toString(), attrs.momentizeParse).format(attrs.momentizeDisplay));

        function onUpdate(){
            elem.text(moment(attrs.momentize.toString(), attrs.momentizeParse).format(attrs.momentizeDisplay));
        }
        attrs.$observe('momentize', onUpdate);
        attrs.$observe('momentizeDisplay', onUpdate);
    }

    return {
        restrict : 'A',
        link : link
    };
}
/**
 * @ngInject
 */

function trackEvent() {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            
            var eventPath = attrs.trackEvent;
            var eventArray = eventPath.split('/');

            var eventCategory = "";
            var eventAction = "";
            var eventLabel = "";

            if (typeof eventArray[0] != 'undefined') {
                eventCategory = eventArray[0].toString();            
            }

            if (typeof eventArray[1] != 'undefined') {
                eventAction = eventArray[1].toString();
            }

            if (typeof eventArray[2] != 'undefined') {
                console.log(eventArray.length, eventArray)
                if(eventArray.length > 2){
                    angular.forEach(eventArray, function(value, key){
                        if(key >= 2){
                            eventLabel += value+"/";
                        }
                    });
                } else {
                    eventLabel = eventArray[2].toString();
                }
            }

            elem[0].addEventListener('click', function(event){
                console.log("trackEvent: \n"+eventCategory+"\n"+eventAction+"\n"+eventLabel)
                try {
                    __gaTracker('send', 'event', eventCategory, eventAction, eventLabel);
                } catch(e){
                    console.warn("trackEvent: Could not track event: \n"+eventCategory+"\n"+eventAction+"\n"+eventLabel)
                }
            });

        }
    }
}
/**
 * @ngInject
 */

function twitterShare () {
    function link (scope, elem, attrs) {

        var leftPosition, topPosition;
        var socialWindowWidthTw = 550;
        var socialWindowHeightTw = 420;
        leftPosition = (window.screen.width / 2) - ((socialWindowWidthTw / 2) + 10);
        topPosition = 200;
        var windowFeaturesTw = "status=no,height=" + socialWindowHeightTw + ",width=" + socialWindowWidthTw + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";

        elem[0].addEventListener('click', function(event){
            window.open("http://twitter.com/share?url=" + encodeURIComponent(attrs.twitterShare) + "", "tweet", windowFeaturesTw);
        });
    }

    return {
        restrict : 'A',
        link : link
    };
}
/**
 * @ngInject
 */
function videoResizer () {

    function onWindowResize () {
        iframe.style.height = el.offsetWidth/ratio+"px";
    }

    function link (scope, elem, attrs) {
        el = elem[0];
        if (el.className === 'vimeo') {
            iframe = el.querySelector('iframe');
            ratio = iframe.getAttribute("width") / iframe.getAttribute("height");
            window.addEventListener('resize', _.debounce(onWindowResize, 250));
            onWindowResize();
        }
    }

    var el, iframe, ratio;

    return {
        restrict : 'A',
        link : link
    };
}
/**
 * @ngInject
 */

function DataService($q, $http) {
    var api = {};
    
    function sendRequest(data) {
        var request = $q.defer();

        $http({
            method : 'POST',
            url : ajaxUrl,
            data : jQuery.param(data),
            headers : {'Content-Type': 'application/x-www-form-urlencoded'} // Tradional $_POST array - not php input stream

        }).then(function (response) {

            if (angular.isDefined(response.config)) {
                if (angular.isDefined(response.config.data)) {
                    console.log(response.config.data.action + "::success", response);
                }
            }

            if (response.data.status === 1) {
                // SUCCESS
                request.resolve(response.data);
            }
            else {
                // PARAM ERROR
                request.reject(response);
            }

        }, function (response) {
            
            // SYSTEM ERROR
            request.reject(response);
        });

        return request.promise;
    }

    // api.saveData = function(formData) {
    //     console.log(formData);
    //     return sendRequest({
    //         action : 'saveData',
    //         message : formData.message
    //     });
    // }

    api.getArchive = function(postType, pageSize) {
        // console.log(formData);
        return sendRequest({
            action : 'archive',
            post_type : postType,
            page_size : pageSize
        });
    }

    api.newsletterSignup = function(email, groupId) {
        // console.log(formData);
        return sendRequest({
            action : 'newsletter',
            email : email,
            id : groupId,
        });
    }


    return api;
}
/**
 * @ngInject
 */

function Tracking() {
    var api = {};

    api.trackEvent = function trackEvent(category, action, label){
        if(typeof __gaTracker === "function"){
            __gaTracker('send', 'event', category, action, label);
        } else {
            console.warn("__gaTracker is not defined. GA data is not tracked:\nC: "+category+"\nA: "+action+"\nL: "+label);
        }
    }

    api.setDimension = function setDimension(dimension, value){
        if(typeof __gaTracker === "function"){
            __gaTracker('set', dimension, value);
        } else {
            console.warn("__gaTracker is not defined. GA dimension not set:\nD: "+dimension+"\nV: "+value);
        }
    }

    return api;
}})(window.angular);